module.exports = __webpack_public_path__ + "static/img/robot-nt.67cc0a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/robot-nt.png
// module id = 0Rq0
// module chunks = 1